<data-table title="Available" (detail)="assignImport($event)" [columns]="columns" [dataProviderParams]="params"
            [dataProvider]="codeSnippetService" [newHeader]="true" [searchAll]="true"></data-table>
<data-table title="Assigned" #assignedCodeSnippetsTable (remove)="removeAssignedCodeSnippet($event)" [columns]="columns"
            [dataProvider]="assignedCodeSnippetsProvider" [newHeader]="true" [searchAll]="true"></data-table>
